import { Team__Adrianes } from "../teams/Adrianes";
import { Team__Cerveceros_2 } from "../teams/Cerveceros_2";
import { Team__Joeles } from "../teams/Joeles";
import { Team__Llamas } from "../teams/Llamas";
import { Team__Lorenas } from "../teams/Lorenas";
import { Team__LosQuintanas } from "../teams/LosQuintanas";
import { Team__Natalias } from "../teams/Natalias";
import { Team__PecanBros } from "../teams/PecanBros";
import { Team__Potros } from "../teams/Potros";
import { Team__Pythons } from "../teams/Pythons";
import { Team__RoadRunner } from "../teams/RoadRunner";
import { Team__RWE } from "../teams/RWE";
import { Team__Wolfpack } from "../teams/Wolfpack";

const Adrianes = {
  team: Team__Adrianes,
  playingPlayers: [],

  goals: 19,
  penaltyGoals: 0,
  isWinner: false,
};

const Cerveceros = {
  team: Team__Cerveceros_2,
  playingPlayers: [],

  goals: 26,
  penaltyGoals: 0,
  isWinner: false,
};

const Natalias = {
  team: Team__Natalias,
  playingPlayers: [],

  goals: 43,
  penaltyGoals: 0,
  isWinner: false,
};

const Joeles = {
  team: Team__Joeles,
  playingPlayers: [],

  goals: 33,
  penaltyGoals: 0,
  isWinner: false,
};

const Llamas = {
  team: Team__Llamas,
  playingPlayers: [],

  goals: 41,
  penaltyGoals: 0,
  isWinner: false,
};

const Lorenas = {
  team: Team__Lorenas,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const LosQuintanas = {
  team: Team__LosQuintanas,
  playingPlayers: [],

  goals: 28,
  penaltyGoals: 0,
  isWinner: false,
};

const PecanBros = {
  team: Team__PecanBros,
  playingPlayers: [],

  goals: 48,
  penaltyGoals: 0,
  isWinner: false,
};

const Potros = {
  team: Team__Potros,
  playingPlayers: [],

  goals: 22,
  penaltyGoals: 0,
  isWinner: false,
};

const Pythons = {
  team: Team__Pythons,
  playingPlayers: [],

  goals: 53,
  penaltyGoals: 0,
  isWinner: false,
};

const RoadRunner = {
  team: Team__RoadRunner,
  playingPlayers: [],

  goals: 34,
  penaltyGoals: 0,
  isWinner: false,
};

const RWE = {
  team: Team__RWE,
  playingPlayers: [],

  goals: 28,
  penaltyGoals: 0,
  isWinner: false,
};

const Wolfpack = {
  team: Team__Wolfpack,
  playingPlayers: [],

  goals: 46,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada2 = {
  jornadaPosition: 2,
  matches: [
    {
      team1: RoadRunner,
      team2: PecanBros,

      isCompleted: true,
      isPlaying: false,
      day: "Martes",
      date: "2025-07-29",
      time: "09:00:00",
      location: "Centro Recreativo Lebaron",
    },
      {
      team1: Joeles,
      team2: Adrianes,

      isCompleted: true,
      isPlaying: true,
      day: "Martes",
      date: "2025-07-29",
      time: "10:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Llamas,
      team2: Potros,

      isCompleted: true,
      isPlaying: true,
      day: "Martes",
      date: "2025-07-29",
      time: "11:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: RWE,
      team2: Natalias,

      isCompleted: true,
      isPlaying: true,
      day: "Martes",
      date: "2025-07-29",
      time: "12:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Pythons,
      team2: LosQuintanas,

      isCompleted: true,
      isPlaying: false,
      day: "Martes",
      date: "2025-07-29",
      time: "16:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Wolfpack,
      team2: Cerveceros,

      isCompleted: true,
      isPlaying: true,
      day: "Martes",
      date: "2025-07-29",
      time: "17:00:00",
      location: "Centro Recreativo Lebaron",
    },
  ],
};
